export default __webpack_public_path__ + "static/media/ERA.61daca93.svg";